// frontend/src/services/calendarService.js
import api from './api';

export const getAllEvents = async () => {
    const response = await api.get('/calendar');
    return response.data;
};

export const createEvent = async (eventData) => {
    const response = await api.post('/calendar', eventData);
    return response.data;
};

export const deleteEvent = async (eventId) => {
    // console.log("Deleting event with ID:", eventId);
    await api.delete(`/calendar/${eventId}`);
};